import React from "react";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import "./Careers.css";
import CareersHero from "../../components/pages/Careers/CareersHero/CareersHero";
import CareersIntro from "../../components/pages/Careers/CareersIntro/CareersIntro";
import CareersOpenPositions from "../../components/pages/Careers/CareersOpenPositions/CareersOpenPositions";
import { usePageContent } from "../../hooks/usePublicQueries";
import { normalizePublicLanguage } from "../../query/publicFetchers";
import { useTranslation } from "react-i18next";
import {
  findPageSection,
  unwrapSectionData,
} from "../../utils/aboutStartNewProjectSection";

/** Prefer current-language CMS values; fill empty fields from English so AR/KU still render. */
const mergeSectionPreferFilled = (primaryRaw, fallbackRaw) => {
  const primary = unwrapSectionData(primaryRaw);
  const fallback = unwrapSectionData(fallbackRaw);
  if (!primary || typeof primary !== "object") {
    return fallback && typeof fallback === "object" ? fallback : primary;
  }
  if (!fallback || typeof fallback !== "object") return primary;

  const out = { ...fallback, ...primary };
  Object.keys(fallback).forEach((key) => {
    const value = out[key];
    const empty =
      value == null ||
      (typeof value === "string" && !String(value).trim()) ||
      (typeof value === "object" &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0);
    if (empty && fallback[key] != null && String(fallback[key]).trim()) {
      out[key] = fallback[key];
    }
  });
  return out;
};

const Careers = () => {
  const { i18n } = useTranslation();
  const language = normalizePublicLanguage(i18n.language);
  const { data: careersContent } = usePageContent("careers", language);
  const { data: careersContentEnRaw } = usePageContent("careers", "en", {
    enabled: language !== "en",
  });
  const careersContentEn = language === "en" ? careersContent : careersContentEnRaw;

  const heroContent = mergeSectionPreferFilled(
    findPageSection(careersContent, "hero"),
    findPageSection(careersContentEn, "hero")
  );
  const introContent = mergeSectionPreferFilled(
    findPageSection(careersContent, "intro"),
    findPageSection(careersContentEn, "intro")
  );

  return (
    <div className="careers-page">
      <Navbar theme="dark" />
      <div className="careers-page-content-guide">
        <CareersHero content={heroContent} />
        <CareersIntro content={introContent} />
        <div id="careers-open-positions">
          <CareersOpenPositions />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Careers;
